module.exports = __webpack_public_path__ + "static/media/Welle-03.12b4258d.svg";